import React from 'react';

import { DEFAULT_CART_FONT_SIZE_TEXT_IN_PX } from '@styles/constants';
import { IBasicTestProps } from '@styles/model';
import { ReactFCV } from '@types';

import { CheckoutPrice } from '../CheckoutPrice';

export const CartPrice: ReactFCV<
  {
    price: number;
    isDualPriceLayout: boolean;
    isColumnLayout: boolean;
    isActive?: boolean;
    fontSize?: string;
    isHighLighted?: boolean;
  } & IBasicTestProps
> = ({ price, isDualPriceLayout, isColumnLayout, isActive, fontSize, isHighLighted = false, ...props }) => {
  // services items have to be all bold when isDualPriceLayout
  const secondCurrencyBold = !(isDualPriceLayout && isColumnLayout);

  return (
    <CheckoutPrice
      isActive={isActive}
      isColumnLayout={isColumnLayout}
      {...props}
      price={price}
      firstCurrency={{
        priceSize: fontSize ?? DEFAULT_CART_FONT_SIZE_TEXT_IN_PX,
        currencySize: fontSize ?? DEFAULT_CART_FONT_SIZE_TEXT_IN_PX,
        bold: isDualPriceLayout,
      }}
      secondCurrency={{
        priceSize: fontSize ?? DEFAULT_CART_FONT_SIZE_TEXT_IN_PX,
        currencySize: fontSize ?? DEFAULT_CART_FONT_SIZE_TEXT_IN_PX,
        bold: secondCurrencyBold,
      }}
      isHighLighted={isHighLighted}
    />
  );
};
